/* eslint-disable no-useless-concat */
import './App.css';
import { Provider } from 'react-redux';
import { StyledEngineProvider, createTheme, ThemeProvider } from '@mui/material/styles';
import { BrowserRouter as Router } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import persistStore from 'redux-persist/es/persistStore';
import AppConfigurations from './routes';
import store from './store';
import Toast from './components/common/toast';

// Import Swiper styles
import { useEffect } from 'react';
import { COOKIE_KEYS, DEALER_STATUS } from './constants/app-constants';
import { setUser } from './store/user/action';
import { enlistDealers } from './store/login/action';
import deleteCookie from './utils/helpers/delete-cookie';
import { setupToast } from './store/toast/action';
import checkLogin from './utils/login/checkLogin';
import { initGA } from './tracking';
const theme = createTheme({
    palette: {
        primary: {
            main: '#0059a0',
        },
        secondary: {
            main: '#e97110',
        },
        active: {
            main: '#6558f5'
        },
        border: {
            main: '#a2a2a2'
        },
        bg: {
            main: '#f0f4f7'
        }
    },
});
function App() {
    const persister = persistStore(store);

    useEffect(() => {
        manageDealer();
        initGA();
    }, []);

    const manageDealer = () => {
        const user = store.getState()?.user;
        if (user?.id && [DEALER_STATUS.BANNED, DEALER_STATUS.ENLISTED].includes(user?.status) && checkLogin()) {
            const phoneNumber = user?.contactPerson?.primaryMobileNumber;
            store.dispatch(enlistDealers({ phoneNumber })).then(dealer => {
                if (dealer?.status !== DEALER_STATUS.BANNED) {
                    store.dispatch(setUser(dealer));
                } else {
                    store.dispatch(setupToast({ message: 'Your id is de-activated for some reason, please contact your RM.' }));
                    deleteCookie(COOKIE_KEYS.ACCESS_TOKEN);
                }
            });
        }
    };
    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persister}>
                <ThemeProvider theme={theme}>
                    <Router>
                        <StyledEngineProvider injectFirst>
                            <AppConfigurations />
                        </StyledEngineProvider>
                    </Router>
                    <Toast />
                </ThemeProvider>
            </PersistGate>
        </Provider>
    );
}

export default App;
